import { render, staticRenderFns } from "./StorefrontNavCategories.vue?vue&type=template&id=59fcf7be"
import script from "./StorefrontNavCategories.vue?vue&type=script&lang=js"
export * from "./StorefrontNavCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports